import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getClusterList = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/careers/clusters/cached/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCareerList = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/careers/careers/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMinEducationList = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/careers/min-educations/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLifeSimulatorCareer = ({ careerId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/careers/life-simulator/${careerId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createCustomCareer = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/careers/custom-careers/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getClusterCareers = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/careers/clusters/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStateStats = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/careers/state-employment-info/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAreas = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/common/areas/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCareersContext = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/careers/context/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStateJobTrends = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/careers/state-top-jobs/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMentorVideos = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/video-qna/qna-videos/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMilitaryCareers = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/careers/military/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAllCareers = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/careers/careers/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const markCareerAsFavorite = ({ version = 'v1', id }) =>
  client
    .request({
      url: `${version}/careers/${id}/favorites/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const markCareerAsUnfavorite = ({ version = 'v1', id }) =>
  client
    .request({
      url: `${version}/careers/${id}/favorites/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const markMilitaryCareerAsFavorite = ({ version = 'v1', id }) =>
  client
    .request({
      url: `${version}/careers/military/${id}/favorites/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const markMilitaryCareerAsUnfavorite = ({ version = 'v1', id }) =>
  client
    .request({
      url: `${version}/careers/military/${id}/favorites/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);
